import { LoginOutlined } from '@mui/icons-material';
import { Container, InputAdornment, Typography, Box } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useLoginUserMutation } from '../../api/apiSlice';
import logo from '../../assets/church.svg';
// import google from '../../assets/google.png';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Form from '../../components/utilities/Form';
import { setToken, setUser } from '../../store/slices/authSlice';
import { appUpdateVersion } from '../../utils/config';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    phone: Yup.string().required().min(9).max(10).label('Phone Number'),
    password: Yup.string().min(6).required().label('Password'),
});

export default function GuestLogin({ setActiveScreen }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [loginUser, { isLoading }] = useLoginUserMutation({});

    const goToResetPassword = () => {
        navigate('/reset-password');
    };

    const onSubmit = async (vals) => {
        const { error, data } = await loginUser({
            username: '0' + vals.phone,
            password: vals.password,
            device_name: 'web',
        });

        errorSnackbar(error, enqueueSnackbar);

        if (data) {
            const user = data.member;
            const token = data.tokens.access_token;
            dispatch(setUser(user));
            dispatch(setToken(token));
            navigate('/guest-profile');
        }
    };

    return (
        <Container sx={{ py: 2 }} maxWidth="sm">
            <Form
                onSubmit={(vals) => onSubmit(vals)}
                validationSchema={validate}
                initialValues={{ phone: '', password: '' }}
            >
                <img style={{ width: 30, height: 30 }} src={logo} alt="logo" />
                <Box sx={{ mt: 6, mb: 4 }}>
                    <Typography variant="h6">Sign in to myKanisa</Typography>
                    <Typography>
                        New user?{' '}
                        <Typography
                            onClick={() => setActiveScreen(1)}
                            className="fw-bold text-underline"
                            color="primary"
                            component="span"
                        >
                            Create new account
                        </Typography>
                    </Typography>
                </Box>
                <FormikInput
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                +254
                            </InputAdornment>
                        ),
                    }}
                    adornment={'+254'}
                    name="phone"
                    placeholder="7XXXXXXXX"
                />
                <FormikInput
                    type="password"
                    name="password"
                    placeholder="Password"
                />
                <div className="d-flex  justify-content-end mb-4">
                    <Typography onClick={goToResetPassword} color="primary">
                        Forgot Password?
                    </Typography>
                </div>
                <FormikButton
                    startIcon={<LoginOutlined />}
                    sx={{ py: 1.5 }}
                    variant="contained"
                    fullWidth
                    loading={isLoading}
                >
                    Log In
                </FormikButton>
                {/* <Box className="d-flex flex-column " sx={{ pt: 2.5, mb: 0.5 }}>
                    <Divider />
                    <Typography
                        color="text.secondary"
                        sx={{
                            alignSelf: 'center',
                            position: 'relative',
                            bgcolor: 'background.default',
                            px: 0.5,
                            top: -12,
                        }}
                    >
                        OR
                    </Typography>
                </Box>
                <Button
                    // className="justify-content-around"
                    startIcon={
                        <img
                            style={{ width: 24, height: 24 }}
                            src={google}
                            alt="logo"
                        />
                    }
                    sx={{
                        py: 1.5,
                        color: '#787878',
                        backgroundColor: '#D9D9D9',
                    }}
                    variant="contained"
                    fullWidth
                    loading={isLoading}
                >
                    Continue with Google
                </Button> */}
                <div
                    style={{
                        position: 'fixed',
                        bottom: 20,
                        left: 0,
                        textAlign: 'center',
                        width: '100%',
                    }}
                >
                    <Typography
                        variant="caption"
                        color="primary"
                        onClick={() => navigate('/terms')}
                    >
                        Terms and conditions .
                    </Typography>
                    <Typography
                        variant="caption"
                        color="primary"
                        onClick={() => navigate('/privacy')}
                    >
                        {' '}
                        Privacy Policy
                    </Typography>
                    <Typography
                        component="div"
                        variant="caption"
                        color="textSecondary"
                    >
                        Version {appUpdateVersion}
                    </Typography>
                </div>
            </Form>
        </Container>
    );
}
